/** Return the preferred name when set; otherwise fall back to legal `name`.
 *
 * Mirror of the Python `display_name` helper at
 * `services/api/src/domain/display_name.py`. Both must agree so a Slack
 * DM and the equivalent web surface render the same string for a given
 * employee. Empty strings fall back to `name` — same semantic as null.
 */
export function displayName(emp: { preferredName: string | null; name: string }): string {
  return emp.preferredName ? emp.preferredName : emp.name
}

/** "Grace Catahay Ungui" → "Grace U" (first name + last initial). */
function firstNameLastInitial(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0]!
  return `${parts[0]} ${parts[parts.length - 1]![0]!.toUpperCase()}`
}

/** Label for a person on a calendar bar (and the Outlook event subject).
 *
 * A preferred name is what the person chose to be called, so it is shown in
 * full. Only the full (legal) name is shortened to first name + last initial.
 * Blank preferred names count as unset. Mirror of the Python `calendar_name`
 * in `services/api/src/domain/display_name.py`.
 */
export function calendarName(emp: { preferredName: string | null; name: string }): string {
  const preferred = emp.preferredName?.trim() ?? ''
  return preferred !== '' ? preferred : firstNameLastInitial(emp.name)
}
